import * as types from './types';

export const fetchApplicationDraftState = (applicationId) => ({
    type: types.CANDIDATE_APPLICATION_DRAFT_FETCH_APPLICATION_DRAFT_STATE,
    applicationId
});

export const setApplicationDraftLoading  = (isApplicationDraftLoading = false) => ({
    type: types.CANDIDATE_APPLICATION_DRAFT_SET_APPLICATION_DRAFT_LOADING,
    isApplicationDraftLoading
});

export const setApplicationDraftState  = (applicationDraftState) => ({
    type: types.CANDIDATE_APPLICATION_DRAFT_SET_APPLICATION_DRAFT_STATE,
    applicationDraftState
});

export const resetApplicationDraftState  = () => ({
    type: types.CANDIDATE_APPLICATION_DRAFT_RESET_APPLICATION_DRAFT_STATE
});

export const deleteApplicationDraft = (applicationId) => ({
    type: types.CANDIDATE_APPLICATION_DRAFT_DELETE_APPLICATION_DRAFT,
    applicationId
});

export const setApplicationCanceling = (isApplicationCanceling) => ({
    type: types.CANDIDATE_APPLICATION_DRAFT_SET_APPLICATION_CANCELING,
    isApplicationCanceling
});

export const setApplicationHasBeenCanceled = (applicationHasBeenCanceled) => ({
    type: types.CANDIDATE_APPLICATION_DRAFT_SET_APPLICATION_HAS_BEEN_CANCELED,
    applicationHasBeenCanceled
});

export const setApplicationSubmitting = (isApplicationSubmitting) => ({
    type: types.CANDIDATE_APPLICATION_DRAFT_SET_APPLICATION_SUBMITTING,
    isApplicationSubmitting
});

export const setApplicationHasBeenSubmitted = (applicationHasBeenSubmitted) => ({
    type: types.CANDIDATE_APPLICATION_DRAFT_SET_APPLICATION_HAS_BEEN_SUBMITTED,
    applicationHasBeenSubmitted
});

export const submitApplicationDraft = (applicationId) => ({
    type: types.CANDIDATE_APPLICATION_DRAFT_SUBMIT_APPLICATION_DRAFT,
    applicationId
});

export const updateCandidateApplicationCoverLetter = (applicationId, applicationCoverLetter) => ({
    type: types.CANDIDATE_APPLICATION_UPDATE_COVER_LETTER,
    applicationId,
    applicationCoverLetter
});

export const setCandidateApplicationCoverLetterUpdating = (isLoading = false) => ({
    type: types.CANDIDATE_APPLICATION_SET_COVER_LETTER_UPDATING,
    isLoading
});

export const updateCandidateApplicationSupplementaryQuestions = (applicationId, applicationSupplementaryQuestions) => ({
    type: types.CANDIDATE_APPLICATION_UPDATE_SUPPLEMENTARY_QUESTIONS,
    applicationId,
    applicationSupplementaryQuestions
});

export const setCandidateApplicationSupplementaryQuestionsUpdating = (isLoading = false) => ({
    type: types.CANDIDATE_APPLICATION_SET_SUPPLEMENTARY_QUESTIONS_UPDATING,
    isLoading
});

export const updateCandidateApplicationSupplementaryQuestionsAnswers = (applicationId, applicationSupplementaryQuestionsAnswers) => ({
    type: types.CANDIDATE_APPLICATION_UPDATE_SUPPLEMENTARY_QUESTIONS_ANSWERS,
    applicationId,
    applicationSupplementaryQuestionsAnswers
});



// WEBPACK FOOTER //
// ./src/actions/candidate/candidate-application-draft/index.js